import { initHeaderAnimation } from './partials/megaMenu.js';
import { initZenChat } from './partials/zendeskChat.js';

document.addEventListener('DOMContentLoaded', () => {
  initHeaderAnimation();
});

window.onload = function () {
  const targetHash = window.__InitialHash;

  if (targetHash) {
    const targetId = targetHash.substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {

      // Use a generous delay to guarantee layout stability
      setTimeout(() => {
        const fixedHeader = document.getElementById('header') || document.getElementById('header-fallback');
        let headerHeight = fixedHeader ? fixedHeader.offsetHeight : 0;

        // Final position calculation
        const scrollPosition = targetElement.offsetTop - headerHeight;

        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth' // Use smooth scroll for the final, intended animation
        });

        window.history.pushState(null, null, targetHash);

      }, 100);
    }
  }
  
  // Load zenChat script
  setTimeout(() => {
    initZenChat();
  }, 3500);
};

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="#"]');
    if (!link || link.hostname !== window.location.hostname || link.pathname !== window.location.pathname) {
      return;
    }

    const targetElement = document.getElementById(link.hash.substring(1));

    if (targetElement) {
      e.preventDefault();

      setTimeout(() => {
        const fixedHeader = document.getElementById('header') || document.getElementById('header-fallback');
        const headerHeight = fixedHeader ? fixedHeader.offsetHeight : 0;

        const scrollPosition = targetElement.offsetTop - headerHeight;

        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });

        window.history.pushState(null, null, link.hash);
      }, 100);
    }
  }, { passive: false });
});
